export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novoUsuario: {
    pt: 'Novo usuário',
    en: 'New user',
    de: 'Neuer Benutzer',
    es: 'Nuevo usuario',
  },
  reportFileName: {
    pt: 'RELATÓRIO-USUÁRIOS-BASF.xlsx',
    en: 'BASF-USERS-REPORT.xlsx',
    de: 'BASF-BENUTZER-BERICHT.xlsx',
    es: 'INFORME-USUARIOS-BASF.xlsx',
  },
  exportar: {
    pt: 'Exportar',
    en: 'Export',
    de: 'Exportieren',
    es: 'Exportar',
  },
};
